import React from 'react';
import { humanReach, milestones, platformLimits } from '../../data/platforms';
import { SourceRef } from '../SourceRef';
export function AgentPlatformsTab() {
  const max = Math.max(...humanReach.map(r => r.users));
  return <>
      <section aria-labelledby="limits-title" data-id="element-400" data-mp="6rv5rn1vnxl9">
        <h2 id="limits-title" className="font-serif text-2xl text-ink md:text-3xl" data-id="element-401" data-mp="asezegn8sj2n">
          Per-user agent limits
        </h2>
        <p className="mt-2 max-w-2xl text-[14px] text-muted" data-id="element-402" data-mp="3a8tr00h21s1b">How many agents can one person make? The answer sets the ceiling on every created-agent count — and most platforms either publish no cap or only just started to.</p>
        <div className="mt-5 overflow-x-auto rounded-lg border border-line" data-id="element-403" data-mp="3j75hm2hx8ptr">
          <table className="w-full min-w-[720px] border-collapse text-[14px]" data-id="element-404" data-mp="3o8cntx4f1gyb">
            <thead className="bg-surface text-left text-[12px] text-muted" data-id="element-405" data-mp="yj0xbf3j8myx">
              <tr data-id="element-406" data-mp="13h2hy4glwuci">
                <th scope="col" className="border-b border-line px-4 py-2.5 font-normal" data-id="element-407" data-mp="13gj8lc50vea3">Platform</th>
                <th scope="col" className="border-b border-line px-4 py-2.5 font-normal" data-id="element-408" data-mp="1xhgdlx8l0dc6">Limit per user</th>
                <th scope="col" className="border-b border-line px-4 py-2.5 font-normal" data-id="element-409" data-mp="1sj581ypbkozr">Details</th>
              </tr>
            </thead>
            <tbody data-id="element-410" data-mp="1nl3ntag5qjmp">
              {platformLimits.map(p => <tr key={p.platform} className="border-b border-line/60 last:border-b-0" data-id="element-411" data-mp="1ij4ihv0uxcn4">
                  <th scope="row" className="whitespace-nowrap px-4 py-3.5 text-left font-normal text-ink" data-id="element-412" data-mp="1ejdw03id5ioe">{p.platform}</th>
                  <td className={`whitespace-nowrap px-4 py-3.5 font-mono text-[13px] ${p.limit === 'Unlimited' ? 'text-machine' : 'text-ink'}`} data-id="element-413" data-mp="19qb1nt5ri575">
                    {p.limit}
                    <SourceRef id={p.sourceId} data-id="element-414" data-mp="zuhj9t5d3hhg" />
                  </td>
                  <td className="px-4 py-3.5 text-muted" data-id="element-415" data-mp="uuv2xau8ll4f">{p.detail}</td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </section>

      <section aria-labelledby="reach-title" className="mt-16 grid gap-12 lg:grid-cols-[minmax(0,1.25fr)_minmax(0,1fr)]" data-id="element-416" data-mp="qv46aqi14arz">
        <div data-id="element-417" data-mp="l6hc3gejnceo">
          <h2 id="reach-title" className="font-serif text-2xl text-ink md:text-3xl" data-id="element-418" data-mp="l6ziv6yu190u">
            Human reach
          </h2>
          <p className="mt-2 text-[14px] text-muted" data-id="element-419" data-mp="789jtlsgcz9u">People who talk to each assistant. Weekly (WAU) and monthly (MAU) figures are not directly comparable.</p>
          <ul className="mt-6 space-y-3.5" data-id="element-420" data-mp="zvvm8qpy1xv4">
            {humanReach.map(r => <li key={r.name} className="grid grid-cols-[6.5rem_minmax(0,1fr)_6.5rem] items-center gap-4" data-id="element-421" data-mp="13x7hbbrl7bap">
                <span className="truncate text-[14px] text-ink" data-id="element-422" data-mp="q62czwd9xuu1">{r.name}</span>
                <div className="h-2.5 rounded-sm bg-raised" aria-hidden="true" data-id="element-423" data-mp="q3zpbizlgdsh">
                  <div className="h-full rounded-sm bg-human/80" style={{
                width: `${Math.max(1.2, r.users / max * 100)}%`
              }} data-id="element-424" data-mp="v32ncjh5pjqy" />
                </div>
                <span className="whitespace-nowrap text-right font-mono text-[13px] tabular text-ink" data-id="element-425" data-mp="1nlq3dkhaq8l6">
                  {r.display}
                  <span className="ml-1 text-[10.5px] text-muted" data-id="element-426" data-mp="1wygq20abnr8b">{r.metric}</span>
                  <SourceRef id={r.sourceId} estimate={r.isEstimate ? {
                low: '50M',
                high: '62M'
              } : undefined} data-id="element-427" data-mp="1sxddpnrhgdbu" />
                </span>
                {r.note && <span className="col-start-2 -mt-2 font-mono text-[11px] text-muted" data-id="element-428" data-mp="26rnu9htbt16t">{r.note}</span>}
              </li>)}
          </ul>
        </div>

        <div data-id="element-429" data-mp="1e1xel4c1pr8l">
          <h2 className="font-serif text-2xl text-ink md:text-3xl" data-id="element-430" data-mp="1e1fkad8y1n3b">Milestones</h2>
          <ol className="relative mt-6 border-l border-line" data-id="element-431" data-mp="1a0vlz6cmwdfl">
            {milestones.map(m => <li key={m.date} className="relative pb-6 pl-6 last:pb-0" data-id="element-432" data-mp="1o04qv9ve3l49">
                <span className={`absolute -left-[5px] top-1.5 h-[9px] w-[9px] rounded-full ${m.current ? 'bg-machine' : 'border border-faint bg-bg'}`} aria-hidden="true" data-id="element-433" data-mp="1izz6merg90w7" />
                <p className="font-mono text-[11.5px] text-muted" data-id="element-434" data-mp="2ufe2ff7x9mpq">{m.date}</p>
                <p className={`mt-0.5 text-[14.5px] ${m.current ? 'text-machine' : 'text-ink'}`} data-id="element-435" data-mp="2uhi3lpefs7mb">
                  {m.label}
                  <SourceRef id={m.sourceId} data-id="element-436" data-mp="18x4ycelx7kr3" />
                </p>
                <p className="mt-0.5 text-[13px] text-muted" data-id="element-437" data-mp="18zhdyl47hj0z">{m.detail}</p>
              </li>)}
          </ol>
        </div>
      </section>
    </>;
}